export default __webpack_public_path__ + "static/media/BlackWaterMap.78878219.jpg";